import { namespaceDocumentId, namespaceType } from './namespace';

const storeLocatorType = namespaceType('storeLocator');
const homePageType = namespaceType('homePage');
const homePageId = namespaceDocumentId('homePage');
const articlesListType = namespaceType('articlesList');
const faqsType = namespaceType('faqs');
const contactUsType = namespaceType('contactUs');

export const SEO_PROJECTION = `
  seo{
    metaTitle,
    metaDescription,
    seoKeywords,
    nofollowAttributes,
    openGraph{
      title, description, siteName, url,
      image{asset->{url, metadata{dimensions}}}
    },
    twitter{ site, creator, cardType },
    additionalMetaTags[]{
      metaAttributes[]{
        attributeKey, attributeType,
        attributeValueString,
        attributeValueImage{asset->{url}}
      }
    }
  }
`;

export const pageBySlug = `
  *[slug.current == $slug && _type in $types][0]{
    "slug": slug.current,
    ${SEO_PROJECTION}
  }
`;

export const storeLocatorSEO = `
*[_type == "${storeLocatorType}"][0]{
  ${SEO_PROJECTION}
}
`;

export const homePageSEO = `
*[_type == "${homePageType}" && _id == "${homePageId}"][0]{
  ${SEO_PROJECTION}
}
`;

export const articlesListSEO = `
*[_type == "${articlesListType}" && type == $type][0]{
  ${SEO_PROJECTION}
}
`;

export const faqsSEO = `
*[_type == "${faqsType}"][0]{
  ${SEO_PROJECTION}
}
`;

export const contactUsSEO = `
*[_type == "${contactUsType}"][0]{
  ${SEO_PROJECTION}
}
`;
